//General
import React, { useMemo, useState, useEffect } from "react";
import { useQueries } from 'react-query'
import Status from "components/presentation/Status";
import LoaderSubComponent from "components/general/LoaderSubComponent";
import { Accordion } from "react-bootstrap";
import { useQueryClient } from "react-query";


//Owner
import SportCode from "components/common/SportCode";
import Loader from 'components/general/Loader'
import { getResultsRSC } from "data/Querys"
import { getRscObject } from "helpers/rsc";
import MirsTable from "components/general/table/Table";
import CaptionTable from "components/general/table/CaptionTable";
import NotAvailable from 'components/common/NotAvailable'
import {
    TableColumnsQualification as ColumnsQualification,
    TableColumnsFinal as ColumnsFinal,
} from 'components/sports/gar/events/rotations/Columns'
import { TableExpanded } from 'components/sports/gar/events/rotations/TableExpanded'
import { isIndAllAround, isTeam } from "components/sports/gar/helper/GarHelpers";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const GarRotations = ({ apparatus }) => {
    //--------------START LOAD DATA
    let _currentRotation = 0;
    const [activeKey, setActiveKey] = useState(-1);
    const [initialKey, setInitialKey] = useState(true);
    const { mirs_competition, mirs_rsc, mirs_language } = useUrlFriendlyToParameters()
    const rscObj = getRscObject(mirs_rsc)
    let queryArray = [];
    Array.isArray(apparatus) && apparatus.forEach((item) => {
        //GARW1APBB-------------QUAL000005--
        let event = "1AP" + item + "-------------";
        let rscQual = rscObj.discipline + rscObj.sex + event + rscObj.phase + rscObj.unit;
        let rsc = isTeam(mirs_rsc) || isIndAllAround(mirs_rsc) ? mirs_rsc : rscQual;
        let queryParams = (isTeam(mirs_rsc) || isIndAllAround(mirs_rsc)) ? ['resultsRotationsApparatus', mirs_competition, rsc, mirs_language, rsc, item] : ['resultsRotationsApparatus', mirs_competition, rsc, mirs_language]

        queryArray.push({
            queryKey: queryParams,
            queryFn: getResultsRSC,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        })
    });

    const results = useQueries(queryArray);
    const isLoading = results.some(result => result.isLoading)
    const isError = results.some(result => result.isError)

    if (isError) { return <NotAvailable />; }
    if (isLoading) { return <Loader />; }
    //--------------END LOAD DATA
    let elements = []
    let _rotation = 0;
    results.map(item => {
        _rotation = item?.data?.results?.extendedInfos.find(item => item.ei_code === "ROTATION" && item.ei_type === 'UI')?.ei_value
        _rotation = _rotation ? Number(_rotation) : 0
        if (_rotation > _currentRotation) {
            _currentRotation = _rotation;
            if (initialKey) {
                setInitialKey(false)
                setActiveKey(_currentRotation)
            }
        }
    });

    apparatus.forEach((item, key) => {
        elements.push(
            <Accordion.Item key={`mirs-rotation-item-${key + 1}`} eventKey={key + 1} >
                <Accordion.Header className={`${_currentRotation === key + 1 ? "active" : ""}`}>Rotation {key + 1}</Accordion.Header>
                <Accordion.Body>
                    <Rotations apparatus={apparatus} rotation={key + 1} />
                </Accordion.Body>
            </Accordion.Item>
        )
    })

    return (
        <Accordion activeKey={activeKey} onSelect={e => setActiveKey(e)} >
            {elements}
        </Accordion>
    )
};



export default GarRotations;



const getConfiguration = (data, isTeam, apparatus, discipline) => {
    const resultStatus = data?.results?.status?.code;
    const scheduleStatus = data?.results?.schedule?.status?.code;
    let configuration = {
        caption: null,
        columns: [],
    };

    //data && data?.results?.eventUnit?.description
    configuration.caption = <CaptionTable
        leftCol={<h4 className="text-dark">{<SportCode discipline={discipline} entity='@Apparatus' code={apparatus} />}</h4>}
        rightCol={<Status typeToPrint="result" scheduleStatus={scheduleStatus} resultStatus={resultStatus} />}
    />

    configuration.columns = isTeam ? ColumnsFinal() : ColumnsQualification()
    return configuration;
};

const Rotations = ({ apparatus, rotation }) => {
    let elements = []
    apparatus.forEach((item) => {
        elements.push(
            <ResultApparatus key={`mirs-rotation-item-${item}-${rotation}`} apparatus={item} rotation={rotation} />
        )
    })
    return (
        <>
            {elements}
        </>
    )
}

const ResultApparatus = ({ apparatus, rotation }) => {
    const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters()
    let data = useGetData(apparatus);
    let itemsArray = [];
    //final: teams sort by startSortOrder, athletes sort by startsortorder(en la tabla)
    //qualification: sort by startOrder
    const itemsSort = data?.results?.items?.sort((a, b) => a?.startSortOrder - b?.startSortOrder)?.map((item => item));
    itemsSort && itemsSort?.map(items => {
        if (items?.eventUnitEntries?.find(evEntry => evEntry.eue_type === 'EUE' && evEntry.eue_code === 'ROTATION' && evEntry.eue_value === apparatus && evEntry.eue_pos === rotation.toString())) {
            if (isTeam(mirs_rsc)) {
                //create data to show in table
                items.teamAthletes.forEach(ath => {
                    let itemClone = {};
                    itemClone["apparatus"] = apparatus;
                    itemClone["rotation"] = rotation.toString();
                    itemClone["codeAth"] = ath?.athlete?.code;
                    itemClone["bib"] = ath?.bib
                    itemClone["startOrder"] = ath?.startOrder;
                    itemClone["participant"] = ath?.athlete;
                    itemClone["extendedResults"] = ath?.extResults;
                    itemClone["startSortOrder"] = ath?.startOrder ? ath?.startOrder : 99;
                    itemClone["resultType"] = ath?.order === 1 ? items?.resultType : '';
                    itemClone["resultIrm"] = ath?.order === 1 ? items?.resultIrm : '';
                    itemClone["resultData"] = ath?.order === 1 ? items?.resultData : '';
                    itemClone["resultDataAth"] = ath?.extResults?.find(item => item.er_code === 'SCORE' && item.er_type === 'ER')?.er_value;
                    if (!itemsArray.find(item => item.codeAth === ath?.athlete?.code && item.apparatus === apparatus && item.rotation === rotation.toString())) {
                        itemsArray.push(itemClone)
                    }
                })
            } else {
                itemsArray.push(items)
            }
        }
    })
    //sort data in order to show in table
    const itemsArraySort = itemsArray.sort((a, b) => b.startSortOrder - a.startSortOrder).map((item => item));
    const resultStatus = data?.results?.status?.code;
    const rsc = data?.results?.eventUnitCode;
    //const bTeam = isTeam(mirs_rsc) || isIndAllAround(mirs_rsc)
    const bTeam = isTeam(mirs_rsc)
    //redraw by resultStatus   
    // eslint-disable-next-line
    const configEvent = useMemo(() => getConfiguration(data, bTeam, apparatus, mirs_discipline), [resultStatus]);

    // Create a function that will render our row sub components
    const renderRowSubComponent = React.useCallback(({ row }) => {
        return (
            <LoaderSubComponent component={
                <TableExpanded row={row?.original} />
            }
            />
        )
        // eslint-disable-next-line
    }, [resultStatus]);
    return (
        <>
            {data?.results?.items
                ? (
                    <>
                        < MirsTable
                            data={itemsArraySort}
                            columns={configEvent.columns}
                            renderRowSubComponent={renderRowSubComponent}
                            keyRow='participant-code'
                            caption={configEvent.caption}
                            id={`mirs-table-result-rotations-${rsc}-${rotation}-${apparatus}`}
                            getRowProps={row => {
                                //Higthlight last competitor 
                                let isCurrent = Array.isArray(row.original?.extendedResultsCurrent) &&
                                    row.original?.extendedResultsCurrent?.find(item =>
                                        item.er_code === 'STAGE' &&
                                        item.er_type === 'ER' &&
                                        item.er_value === "LAST") &&
                                    row.original?.extendedResultsCurrent.length > 0
                                return {
                                    className: isCurrent ? 'currentIndicator' : '',
                                }
                            }}
                        />
                    </>
                ) : (
                    <NotAvailable />
                )
            }
        </>
    );

}

function useGetData(apparatus) {
    const { mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
    const rscObj = getRscObject(mirs_rsc)
    let event = "1AP" + apparatus + "-------------";
    // let rsc = isTeam(mirs_rsc) ? mirs_rsc : rscObj.discipline + rscObj.sex + event + rscObj.phase + rscObj.unit;

    let rscQual = rscObj.discipline + rscObj.sex + event + rscObj.phase + rscObj.unit;
    let rsc = (isTeam(mirs_rsc) || isIndAllAround(mirs_rsc)) ? mirs_rsc : rscQual;
    let query = (isTeam(mirs_rsc) || isIndAllAround(mirs_rsc)) ? ['resultsRotationsApparatus', mirs_competition, rsc, mirs_language, rsc, apparatus] : ['resultsRotationsApparatus', mirs_competition, rsc, mirs_language]
    const queryClient = useQueryClient();
    const data = queryClient.getQueryData(query);
    return data
}